import { useApi } from '@backstage/core-plugin-api';
import { sev2ApiRef } from '@internal/backstage-plugin-sev2/src/api';
import { User } from '@internal/backstage-plugin-sev2/src/types';
import { useEffect, useState } from 'react';
import { debounce } from '@mui/material/utils';

const useSev2UserCombobox: () => {
  loading: boolean;
  open: boolean;
  options: User[];
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOptions: React.Dispatch<React.SetStateAction<User[]>>;
  searchUsers: (search: string) => Promise<void>;
} = () => {
  const api = useApi(sev2ApiRef);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<User[]>([]);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      const response = await api.getUserByName({});

      if (active) {
        setOptions(response.result.data);
      }
    })();

    return () => {
      active = false;
    };
  }, [api, loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open, options]);

  const searchUsers = debounce(async (search: string) => {
    const response = await api.getUserByName({ name: search });
    setOptions(response.result.data);
  }, 500);

  return {
    loading,
    open,
    options,
    setOpen,
    setOptions,
    searchUsers,
  };
};

export default useSev2UserCombobox;
